var React = require('react');

function RoughEdgeLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#D5857D","d":"M880.327-358.185v1600.001H736.042c10.247-59.972,142.201-111.546,95.832-155.683\r\n\tc-48.229-45.908-86.616-156.089-43.308-195.799c43.308-39.71-43.308-41.94,0-93.257c43.308-51.317,53.151-134.459,0-163.044\r\n\tc-25.824-13.889,18.192-56.476,24.268-98.588c6.365-44.115-23.658-69.119-24.259-92.91l-0.009-0.72v-0.001l0.009-0.72\r\n\tc0.601-23.79,30.624-48.795,24.259-92.91c-6.076-42.111-50.093-84.699-24.268-98.587c53.151-28.585,43.308-111.727,0-163.044\r\n\tc-43.308-51.317,43.308-53.547,0-93.257c-43.308-39.71-4.921-149.891,43.308-195.799c46.369-44.137-85.585-95.711-95.832-155.683\r\n\tH880.327z"}));
}

RoughEdgeLeft.defaultProps = {"viewBox":"736.042 -358.185 144.285 1600.001","preserveAspectRatio":"none"};

module.exports = RoughEdgeLeft;

RoughEdgeLeft.default = RoughEdgeLeft;
